import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, vModelText as _vModelText, vShow as _vShow } from "vue"

const _hoisted_1 = { class: "transBox" }
const _hoisted_2 = { class: "transBoxInner" }
const _hoisted_3 = { class: "transTitle" }
const _hoisted_4 = { class: "transPrompt" }
const _hoisted_5 = {
  key: 0,
  class: "aiTextBoxTop"
}
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "aiTextBoxTop" }
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "aiTextBoxTop" }
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "aiTextBoxTop" }
const _hoisted_12 = { class: "transBtn" }
const _hoisted_13 = { class: "btnBox" }

import {
    Close,
} from "@element-plus/icons-vue";
import { ref, onMounted } from 'vue'
import { languageList,styleList} from "./icon.ts"

export default /*@__PURE__*/_defineComponent({
  __name: 'translate',
  props: {
    languagefrom:String
},
  emits: ['closeThis','recognition'],
  setup(__props, { emit: __emit }) {

const props = __props
const showFrom=ref(false)
onMounted(()=>{
    console.log(props.languagefrom)
    fromlanguage.value=props.languagefrom

    if(props.languagefrom==undefined||props.languagefrom==''){
        showFrom.value=true
    }
})
const emit = __emit
const changeSelect=()=>{
    console.log(fromlanguage.value)
}
// 关闭弹窗
const closeBox=()=>{
    emit('closeThis')
}

const tolanguage = ref('')
const fromlanguage=ref('')
const handleClose = () => {
    // console.log(tolanguage.value)
    if(tolanguage.value==''){
        return
    }
    emit('recognition',[tolanguage.value,fromlanguage.value,selstyliza.value,dataCustom.value])
}
const stylizaShow=ref(false)//自定义风格展示
const selstyliza=ref('')//选择语言风格
const dataCustom=ref('')
const changeselstyliza=()=>{
    console.log(selstyliza.value)
    if(selstyliza.value=='自定义') stylizaShow.value=true
    if(selstyliza.value!='自定义') stylizaShow.value=false
}


return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[5] || (_cache[5] = _createElementVNode("span", null, "翻译", -1)),
        _createElementVNode("span", {
          class: "closeBtn",
          onClick: _withModifiers(closeBox, ["stop"])
        }, [
          _createVNode(_component_el_icon, null, {
            default: _withCtx(() => [
              _createVNode(_unref(Close))
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        (showFrom.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _cache[6] || (_cache[6] = _createElementVNode("div", { class: "aiTextBoxTopTitle" }, "源语言", -1)),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((fromlanguage).value = $event)),
                class: "toselect",
                onChange: changeSelect
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(languageList), (item, index) => {
                  return (_openBlock(), _createElementBlock("option", {
                    value: item.value,
                    key: index
                  }, _toDisplayString(item.text), 9, _hoisted_6))
                }), 128))
              ], 544), [
                [_vModelSelect, fromlanguage.value]
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_7, [
          _cache[7] || (_cache[7] = _createElementVNode("div", { class: "aiTextBoxTopTitle" }, "目标语言", -1)),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((tolanguage).value = $event)),
            class: "toselect"
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(languageList).filter(it=>it.value!=fromlanguage.value), (item, index) => {
              return (_openBlock(), _createElementBlock("option", {
                value: item.value,
                key: index
              }, _toDisplayString(item.text), 9, _hoisted_8))
            }), 128))
          ], 512), [
            [_vModelSelect, tolanguage.value]
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _cache[8] || (_cache[8] = _createElementVNode("div", { class: "aiTextBoxTopTitle" }, "翻译风格", -1)),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selstyliza).value = $event)),
            class: "toselect",
            onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"])),
            onChange: changeselstyliza
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(styleList), (item, index) => {
              return (_openBlock(), _createElementBlock("option", {
                value: item.value,
                key: index
              }, _toDisplayString(item.text), 9, _hoisted_10))
            }), 128))
          ], 544), [
            [_vModelSelect, selstyliza.value]
          ])
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_11, [
          _withDirectives(_createElementVNode("textarea", {
            style: {"width":"100%"},
            rows: 4,
            type: "textarea",
            class: "textareaCustomBox",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((dataCustom).value = $event)),
            placeholder: "请输入风格内容，例如：\n欧式言情，旧时代，童话，夸张"
          }, null, 512), [
            [_vModelText, dataCustom.value]
          ])
        ], 512), [
          [_vShow, stylizaShow.value]
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("span", {
              class: "btnNo",
              onClick: _withModifiers(closeBox, ["stop"])
            }, "取消"),
            _createElementVNode("span", {
              class: "btnOk",
              onClick: _withModifiers(handleClose, ["stop"])
            }, "确定")
          ])
        ])
      ])
    ])
  ]))
}
}

})